module.exports = __webpack_public_path__ + "static/media/3.74bd603c.jpg";